var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"border-radius":"50%"},attrs:{"src":_vm.avatarSrc,"width":"75","height":"75"}})}
var staticRenderFns = []

export { render, staticRenderFns }